import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';
import { Global } from '../../global';
import { GrupoAccesoRegistro } from '../models/seguridad/grupo_acceso.model';

@Injectable({
    providedIn: 'root',
})
export class SeguridadService {
    prefix = Global.PREFIX_RECORD;
    LOCK_KEY = 'blockedProcess';
    LOCK_EXPIRATION = 60 * 1000; // 60 segundos

    constructor() {}

    getCurrentUser(): any | null {
        const userEncrypt = localStorage.getItem(
            `${this.prefix}.usuarioActivo`,
        );
        let userStr = null;
        if (userEncrypt) {
            userStr = CryptoJS.AES.decrypt(
                userEncrypt,
                environment.SECRET_KEY,
            ).toString(CryptoJS.enc.Utf8);
            return JSON.parse(userStr);
        }
        return userStr;
    }

    async setCurrentUser(user?: any) {
        if (user) {
            const userEncrypt = CryptoJS.AES.encrypt(
                JSON.stringify(user),
                environment.SECRET_KEY,
            ).toString();
            localStorage.setItem(`${this.prefix}.usuarioActivo`, userEncrypt);
        } else {
            localStorage.removeItem(`${this.prefix}.usuarioActivo`);
        }
    }

    async setUserRemember(obj: any | null) {
        if (obj) {
            const userEncrypt = CryptoJS.AES.encrypt(
                JSON.stringify(obj),
                environment.SECRET_KEY,
            ).toString();
            localStorage.setItem(`${this.prefix}.userRemember`, userEncrypt);
        } else {
            localStorage.removeItem(`${this.prefix}.userRemember`);
        }
    }

    getUserRemember() {
        const userEncrypt = localStorage.getItem(`${this.prefix}.userRemember`);
        let userStr = null;
        if (userEncrypt) {
            userStr = CryptoJS.AES.decrypt(
                userEncrypt,
                environment.SECRET_KEY,
            ).toString(CryptoJS.enc.Utf8);
            return JSON.parse(userStr);
        }
        return userStr;
    }

    async setToken(token?: string) {
        if (token) {
            const objEncrypt = CryptoJS.AES.encrypt(
                token,
                environment.SECRET_KEY,
            ).toString();
            localStorage.setItem(`${this.prefix}.token`, objEncrypt);
        } else {
            localStorage.removeItem(`${this.prefix}.token`);
        }
    }

    getToken() {
        const tokenEncrypt = localStorage.getItem(`${this.prefix}.token`)!;
        const tokenStr = CryptoJS.AES.decrypt(
            tokenEncrypt,
            environment.SECRET_KEY,
        ).toString(CryptoJS.enc.Utf8);
        return tokenStr;
    }

    getGrupoAcceso() {
        const userEncrypt = localStorage.getItem(
            `${this.prefix}.usuarioActivo`,
        );
        let userStr = null;
        if (userEncrypt) {
            userStr = CryptoJS.AES.decrypt(
                userEncrypt,
                environment.SECRET_KEY,
            ).toString(CryptoJS.enc.Utf8);
            return JSON.parse(userStr)?.grupo_acceso;
        }
        return userStr;
    }

    async puedeCrear(codigoModulo: string, codigoRegistro: string) {
        const grupo = this.getCurrentUser().grupo_acceso;
        // verificamos que tenga acceso total
        if (grupo.acceso_total) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo(grupo, codigoModulo);
        if (modulo?.acceso_total) {
            return true;
        }
        // verificamos que tenga acceso al registro
        const resp = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );
        if (resp?.crear) {
            return true;
        }

        return false;
    }

    async puedeEditar(codigoModulo: string, codigoRegistro: string) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if (grupo.acceso_total) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo(grupo, codigoModulo);
        if (modulo?.acceso_total) {
            return true;
        }
        const resp = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );

        if (resp?.editar) {
            return true;
        }

        return false;
    }

    async puedeEliminar(codigoModulo: string, codigoRegistro: string) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if (grupo.acceso_total) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo(grupo, codigoModulo);
        if (modulo?.acceso_total) {
            return true;
        }
        const resp = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );
        if (resp?.eliminar) {
            return true;
        }

        return false;
    }

    async puedeAnular(codigoModulo: string, codigoRegistro: string) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if (grupo.acceso_total) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo(grupo, codigoModulo);
        if (modulo?.acceso_total) {
            return true;
        }
        const resp = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );
        if (resp?.anular) {
            return true;
        }

        return false;
    }

    async puedeAprobar(codigoModulo: string, codigoRegistro: string) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if (grupo.acceso_total) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo(grupo, codigoModulo);
        if (modulo?.acceso_total) {
            return true;
        }
        const resp = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );
        if (resp?.aprobar) {
            return true;
        }

        return false;
    }

    async puedeInactivar(codigoModulo: string, codigoRegistro: string) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if (grupo.acceso_total) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo(grupo, codigoModulo);
        if (modulo?.acceso_total) {
            return true;
        }
        const resp = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );
        if (resp?.inactivar) {
            return true;
        }

        return false;
    }

    async puedeRevertirInactivacion(
        codigoModulo: string,
        codigoRegistro: string,
    ) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if (grupo.acceso_total) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo(grupo, codigoModulo);
        if (modulo?.acceso_total) {
            return true;
        }
        const resp = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );
        if (resp?.revertir_inactivacion) {
            return true;
        }

        return false;
    }

    async puedeRevertirAnulacion(codigoModulo: string, codigoRegistro: string) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if (grupo.acceso_total) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo(grupo, codigoModulo);
        if (modulo?.acceso_total) {
            return true;
        }
        const resp = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );
        if (resp?.revertir_anulacion) {
            return true;
        }

        return false;
    }

    async puedeRevertirAprobacion(
        codigoModulo: string,
        codigoRegistro: string,
    ) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if (grupo.acceso_total) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo(grupo, codigoModulo);
        if (modulo?.acceso_total) {
            return true;
        }
        const resp = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );
        if (resp?.revertir_aprobacion) {
            return true;
        }

        return false;
    }

    async puedeSincronizar(codigoModulo: string, codigoRegistro: string) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if (grupo.acceso_total) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo(grupo, codigoModulo);
        if (modulo?.acceso_total) {
            return true;
        }
        const resp = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );
        if (resp?.sincronizar) {
            return true;
        }
        return false;
    }

    async puedeImportar(codigoModulo: string, codigoRegistro: string) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if (grupo.acceso_total) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo(grupo, codigoModulo);
        if (modulo?.acceso_total) {
            return true;
        }
        const resp = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );
        if (resp?.importar) {
            return true;
        }

        return false;
    }

    async puedeExportar(codigoModulo: string, codigoRegistro: string) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if (grupo.acceso_total) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo(grupo, codigoModulo);
        if (modulo?.acceso_total) {
            return true;
        }
        const resp = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );
        if (resp?.exportar) {
            return true;
        }

        return false;
    }

    async puedeImprimir(codigoModulo: string, codigoRegistro: string) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if (grupo.acceso_total) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo(grupo, codigoModulo);
        if (modulo?.acceso_total) {
            return true;
        }
        const resp = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );
        if (resp?.imprimir) {
            return true;
        }

        return false;
    }

    async tienePermisoEspecial(codigo: string) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if (grupo.acceso_total) {
            return true;
        }
        const resp = grupo.permisos.find(
            (permiso: Record<string, any>) => permiso['codigo'] === codigo,
        );
        if (resp?.activo) {
            return true;
        }

        return false;
    }

    async getModulo(grupo: Record<string, any>, codigoModulo: string) {
        const modulo = grupo['modulos'].find(
            (modulo: Record<string, any>) => modulo['codigo'] === codigoModulo,
        );
        return modulo;
    }

    async getRegistro(
        grupo: Record<string, any>,
        codigoModulo: string,
        codigoRegistro: string,
    ) {
        const registro = grupo['registros'].find(
            (registro: Record<string, any>) =>
                registro['modulo'] === codigoModulo &&
                registro['codigo'] === codigoRegistro,
        );
        return registro;
    }

    async getSucursales(
        grupo: Record<string, any>,
        codigoModulo: string,
        codigoRegistro: string,
    ) {
        const sucursales: Record<string, any>[] = [];
        const registro = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );
        return sucursales;
    }

    async tipoAcceso(codigoModulo: string, codigoRegistro: string) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if (grupo.acceso_total) {
            return GrupoAccesoRegistro.ACCESO_TODO;
        }

        const modulo = await this.getModulo(grupo, codigoModulo);
        if (modulo?.acceso_total) {
            return GrupoAccesoRegistro.ACCESO_TODO;
        }

        const resp = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );
        return resp.acceso;
    }

    async processIsBlocked(): Promise<boolean> {
        const lock = localStorage.getItem(this.LOCK_KEY);
        if (!lock) return false;

        const lockTime = Number(lock);
        return Date.now() - lockTime < this.LOCK_EXPIRATION;
    }

    async blockProcess() {
        const lock = localStorage.getItem(this.LOCK_KEY);
        if (lock) {
            const lockTime = Number(lock);
            if (Date.now() - lockTime < this.LOCK_EXPIRATION) return false; //NO SE PUEDE BLOQUEAR SI AUN SIGUE ACTIVO EL LOCKTIME
        }
        localStorage.setItem(this.LOCK_KEY, Date.now().toString());
        const stillMine = localStorage.getItem(this.LOCK_KEY);

        if (stillMine) {
            return !!(stillMine !== lock);
        }
        return true;
    }

    async unblockProcess() {
        localStorage.removeItem(this.LOCK_KEY);
    }

    async canCopyForm(codigoModulo: string, codigoRegistro: string) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if (grupo.acceso_total) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo(grupo, codigoModulo);
        if (modulo?.acceso_total) {
            return true;
        }
        const resp = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );
        if (resp?.copiar_form) {
            return true;
        }
        return false;
    }

    async canPasteForm(codigoModulo: string, codigoRegistro: string) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if (grupo.acceso_total) {
            return true;
        }

        const modulo = await this.getModulo(grupo, codigoModulo);
        if (modulo?.acceso_total) {
            return true;
        }
        const resp = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );
        if (resp?.pegar_form) {
            return true;
        }
        return false;
    }

    async canLoadFormFromFile(codigoModulo: string, codigoRegistro: string) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if (grupo.acceso_total) {
            return true;
        }

        const modulo = await this.getModulo(grupo, codigoModulo);
        if (modulo?.acceso_total) {
            return true;
        }
        const resp = await this.getRegistro(
            grupo,
            codigoModulo,
            codigoRegistro,
        );
        if (resp?.cargar_datos_por_archivo) {
            return true;
        }
        return false;
    }
}
